<template>
  <div>
    <v-btn-toggle
      v-model="innerValue"
      :multiple="multiple"
      :mandatory="mandatory"
    >
      <!-- <slot name="buttons" v-bind:item="n"></slot> -->
      <slot name="buttons"></slot>
    </v-btn-toggle>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        innerValue: [],
        innerValueOnce: false
      };
    },
    watch: {
      innerValue (v) {
        if (!this.innerValueOnce) {
          this.$emit("input", v);
        }
        else {
          this.innerValueOnce = false;
        }
      },
      value (v) {
        this.innerValue = v;
      }
    },
    props: {
      value: [String, Number, Array],
      multiple: Boolean,
      mandatory: Boolean
    },
    mounted () {
      this.innerValue = this.value;
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ButtonToggle.vue